import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { groupFulfillmentOrderLineItems } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export const ItemNameCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Items",
    cell: (row) => {
      const lineItems = groupFulfillmentOrderLineItems(row.items);
      return (
        Array.from(
          new Set(lineItems?.map((item) => item.title).filter(Boolean)),
        )?.join(", ") ?? ""
      );
    },
    expandedCsvCell: (row, expansionIndex) => {
      return getExpandedItems(row)?.[expansionIndex]?.title ?? "";
    },
  };
